function accordion(element) {
  $(element).on("click", function() {
    const $this = $(this);
    const $accordion = $this.closest(".accordion");
    $accordion.siblings().removeClass('active').find('.accordion__content').slideUp();
    $accordion.toggleClass("active");
    $accordion.find(".accordion__content").slideToggle();
  });
}

module.exports = {
  accordion
};

accordion('.js-accordion-toggle')